module.exports = __webpack_public_path__ + "static/media/light.609688e0.png";